import { render, staticRenderFns } from "./CustomerCreatedAtReport.vue?vue&type=template&id=850181b4&scoped=true&"
import script from "./CustomerCreatedAtReport.vue?vue&type=script&lang=js&"
export * from "./CustomerCreatedAtReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreatedAtReport.vue?vue&type=style&index=0&id=850181b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850181b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCheckbox,VCol,VContainer,VForm,VRow})
